import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import {
  PasienPendaftaranParams,
  PasienPendaftaranResponse
} from "@/types/daftarPasienPendaftaran";

async function getList(
  params: PasienPendaftaranParams
): Promise<PasienPendaftaranResponse> {
  const response = await http
    .getDataParam("/daftar-pasien-pendaftaran", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getList
};
